(function () {
  var form = document.getElementById('hb-product-form');
  var variantInput = document.getElementById('hb-product-variant-id');
  var addBtn = document.getElementById('hb-product-add');
  var addLabel = document.querySelector('.hb-product__add-label');
  var qtyInput = document.getElementById('hb-qty-input');
  var qtyMinus = document.getElementById('hb-qty-minus');
  var qtyPlus = document.getElementById('hb-qty-plus');
  var mQtyMinus = document.getElementById('hb-m-qty-minus');
  var mQtyPlus = document.getElementById('hb-m-qty-plus');
  var mQtyDisplay = document.getElementById('hb-m-qty-display');
  var mBuyBtn = document.getElementById('hb-m-buy-now');
  var mBuyPrice = document.getElementById('hb-m-buy-now-price');
  var mobileBar = document.querySelector('.hb-product__mobile-bar');
  var variants = window.__hbProductVariants || [];

  // --- Mobile buy bar: sits normally in the page until scrolled past, then
  //     pins to the bottom of the viewport and stays there for the rest of
  //     the page. Uses plain scroll position rather than IntersectionObserver
  //     so it doesn't depend on assumptions about the page's scroll
  //     container. ---
  if (mobileBar) {
    var mobileBarNaturalTop = mobileBar.getBoundingClientRect().top + window.scrollY;
    var pinTickScheduled = false;

    function updateMobileBarPin() {
      pinTickScheduled = false;
      var scrollBottom = window.scrollY + window.innerHeight;
      var pinThreshold = mobileBarNaturalTop + mobileBar.offsetHeight;
      mobileBar.classList.toggle('is-pinned', scrollBottom >= pinThreshold);
    }

    function remeasureMobileBarNaturalTop() {
      if (mobileBar.classList.contains('is-pinned')) return;
      mobileBarNaturalTop = mobileBar.getBoundingClientRect().top + window.scrollY;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!pinTickScheduled) {
          pinTickScheduled = true;
          requestAnimationFrame(updateMobileBarPin);
        }
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      remeasureMobileBarNaturalTop();
      updateMobileBarPin();
    });

    // Accordion items above the bar can change its natural position when
    // opened/closed — remeasure after any toggle.
    document.querySelectorAll('.hb-product__accordion').forEach(function (details) {
      details.addEventListener('toggle', function () {
        remeasureMobileBarNaturalTop();
        updateMobileBarPin();
      });
    });

    updateMobileBarPin();
  }

  // --- Variant selection ---
  var optionSelects = document.querySelectorAll('.hb-product__option-select');

  function getSelectedOptions() {
    var selected = [];
    optionSelects.forEach(function (select) {
      selected[parseInt(select.getAttribute('data-option-index'), 10)] = select.value;
    });
    return selected;
  }

  function findMatchingVariant(selected) {
    return variants.filter(function (variant) {
      return variant.options.every(function (value, i) {
        return value === selected[i];
      });
    })[0];
  }

  function formatMoney(cents) {
    var moneyFormat = variantInput.getAttribute('data-money-format') || '{{amount}}';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return moneyFormat.replace(/\{\{\s*amount\w*\s*\}\}/, amount);
  }

  function updateVariantUI(variant) {
    if (!variant) return;
    variantInput.value = variant.id;

    // hb-product-gallery.js exposes goToMedia() specifically for this — scroll
    // the gallery to this variant's own photo when one is set.
    var gallery = document.querySelector('hb-gallery');
    if (gallery && variant.featured_media && typeof gallery.goToMedia === 'function') {
      gallery.goToMedia(variant.featured_media.id);
    }

    var formattedPrice = formatMoney(variant.price);

    var priceEl = document.querySelector('.hb-product__price-amount');
    if (priceEl) priceEl.textContent = formattedPrice;

    if (mBuyPrice) mBuyPrice.textContent = formattedPrice;

    var availEl = document.querySelector('.hb-product__availability');
    if (availEl) availEl.classList.toggle('hb-product__availability--out', !variant.available);

    if (addBtn) addBtn.disabled = !variant.available;
    if (addLabel) {
      addLabel.textContent = variant.available
        ? addLabel.getAttribute('data-default-label')
        : ((window.hbStrings || {}).soldOut || 'Loppuunmyyty');
    }
    if (mBuyBtn) mBuyBtn.disabled = !variant.available;
  }

  optionSelects.forEach(function (select) {
    select.addEventListener('change', function () {
      updateVariantUI(findMatchingVariant(getSelectedOptions()));
    });
  });

  // --- Quantity stepper (desktop input + mobile display share the same value) ---
  function setQty(value) {
    var next = Math.max(1, value);
    if (qtyInput) qtyInput.value = next;
    if (mQtyDisplay) mQtyDisplay.textContent = next;
  }

  function getQty() {
    return parseInt((qtyInput && qtyInput.value) || (mQtyDisplay && mQtyDisplay.textContent), 10) || 1;
  }

  if (qtyMinus) {
    qtyMinus.addEventListener('click', function () {
      setQty(getQty() - 1);
    });
  }
  if (qtyPlus) {
    qtyPlus.addEventListener('click', function () {
      setQty(getQty() + 1);
    });
  }
  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      setQty(getQty());
    });
  }
  if (mQtyMinus) {
    mQtyMinus.addEventListener('click', function () {
      setQty(getQty() - 1);
    });
  }
  if (mQtyPlus) {
    mQtyPlus.addEventListener('click', function () {
      setQty(getQty() + 1);
    });
  }

  // --- AJAX add to cart (drives both the desktop button and the mobile sticky bar) ---
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if ((addBtn && addBtn.disabled) || (mBuyBtn && mBuyBtn.disabled)) return;

      var originalDesktopText = addLabel ? addLabel.textContent : '';
      var originalMobileText = mBuyBtn ? mBuyBtn.innerHTML : '';

      if (addBtn) {
        addBtn.disabled = true;
        addBtn.classList.add('is-loading');
      }
      if (mBuyBtn) {
        mBuyBtn.disabled = true;
        mBuyBtn.classList.add('is-loading');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantInput.value,
          quantity: getQty()
        })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error(data.description || 'Add to cart failed');
            });
          }
          return res.json();
        })
        .then(function () {
          if (addBtn) {
            addBtn.classList.remove('is-loading');
            addBtn.classList.add('is-added');
          }
          if (addLabel) addLabel.textContent = ((window.hbStrings || {}).added || 'Lisätty!');
          if (mBuyBtn) {
            mBuyBtn.classList.remove('is-loading');
            mBuyBtn.classList.add('is-added');
            mBuyBtn.textContent = ((window.hbStrings || {}).added || 'Lisätty!');
          }
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          setTimeout(function () {
            if (addBtn) {
              addBtn.classList.remove('is-added');
              addBtn.disabled = false;
            }
            if (addLabel) addLabel.textContent = originalDesktopText;
            if (mBuyBtn) {
              mBuyBtn.classList.remove('is-added');
              mBuyBtn.disabled = false;
              mBuyBtn.innerHTML = originalMobileText;
            }
          }, 2000);
        })
        .catch(function (err) {
          if (addBtn) {
            addBtn.classList.remove('is-loading');
            addBtn.disabled = false;
          }
          if (addLabel) addLabel.textContent = ((window.hbStrings || {}).error || 'Virhe — yritä uudelleen');
          if (mBuyBtn) {
            mBuyBtn.classList.remove('is-loading');
            mBuyBtn.disabled = false;
            mBuyBtn.textContent = ((window.hbStrings || {}).error || 'Virhe — yritä uudelleen');
          }
          setTimeout(function () {
            if (addLabel) addLabel.textContent = originalDesktopText;
            if (mBuyBtn) mBuyBtn.innerHTML = originalMobileText;
          }, 2500);
          console.error('HejBuddy product page add-to-cart error:', err);
        });
    });
  }
})();
